// Package Imports
import {
  DownOutlined,
  FilterOutlined,
  HolderOutlined,
  InfoCircleOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { Button, Tooltip } from 'antd';
import moment from 'moment';

// Project Imports

import SearchInput from 'components/search/searchInput';
import constants from 'core/constants/Constants';
import openNotificationWithIcon from 'core/utils/notification';
import PrivateRouteConst from 'core/common/privateRouteConstant';

const GroupRuleListSubcomponent = ({
  functionHandler,
  stateData,
  stateFunctionHandler,
}) => {
  const t = useTranslate();
  // prettier-ignore
  const {renderRuleGroupDeleteButton,renderRuleDeleteButton,filterRules,handleSetActiveState,toggleRuleGroup,handleDrop,handleDragOver,handleDragStart,handleOpenFilterModal,renderCopyButton,checkPermission}=functionHandler
  const { enabledDivWidth, pageType, ruleGroupList, id } = stateData;
  const { setId } = stateFunctionHandler;

  return (
    <div
      className="enabledDiv mr-sm p-md"
      style={{
        width: `${enabledDivWidth}%`,
        minWidth: '20%',
        maxWidth: '60%',
        border: '1px solid var(--neutral-40)',
      }}
    >
      <div className="flex justify-center items-center">
        <SearchInput
          name="Search"
          placeholder="Search"
          onChange={(e) => filterRules(e.target.value)}
        />
      </div>
      <Tooltip
        className="flex justify-end mt-sm"
        title={
          <span className="text-sm">
            {t('ruleGroup.messages.payoutFormulaInfo')}
          </span>
        }
      >
        <InfoCircleOutlined className="text-2xl" />
      </Tooltip>
      <div
        className={`flex ${pageType === 'Show' ? 'justify-end' : 'justify-between'}`}
      >
        {pageType === 'Show' ? null : (
          <>
            <Button
              className="secondary-btn my-sm"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleSetActiveState('group', 'Create');
                setId(undefined);
              }}
            >
              {t('rules.createGroup')}
            </Button>
            <Button
              className="secondary-btn my-sm"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleSetActiveState('rule', 'Create');
                setId(undefined);
              }}
            >
              {t('rules.createRule')}
            </Button>
          </>
        )}
        {ruleGroupList?.some((ruleGroup) => ruleGroup.rule_list.length > 0) &&
        checkPermission(PrivateRouteConst.SHOW_GRID_FILTER) ? (
          <div
            tabIndex={0}
            className="secondary-btn my-sm p-sm px-md cursor-pointer"
            onClick={handleOpenFilterModal}
          >
            <FilterOutlined />
          </div>
        ) : null}
      </div>
      <div className="rule-group-list">
        {ruleGroupList?.length > 0
          ? ruleGroupList.map((ruleGroup, index) => (
              <div
                key={index}
                className="py-xs mt-sm rule-list-submenu"
                style={{
                  padding: '10px',
                  border: '1px solid var(--neutral-60)',
                  width: '100%',
                  position: 'relative',
                  cursor: 'grab',
                }}
                draggable
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, index)}
              >
                <div>
                  <div className="">
                    <button
                      className="rounded-md border-0 cursor-move"
                      style={{
                        position: 'absolute',
                        left: '-14px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                      }}
                    >
                      <HolderOutlined />
                    </button>
                  </div>
                  <div
                    className="flex text-center break-all"
                    onClick={() => toggleRuleGroup(index)}
                  >
                    {ruleGroup?.rule_list?.length > 0 ? (
                      <div className="cursor-pointer flex self-start mt-sm py-sm pr-sm pl-0.5">
                        {ruleGroup?.expanded ? (
                          <DownOutlined />
                        ) : (
                          <RightOutlined />
                        )}
                      </div>
                    ) : (
                      <div className="ml-md" />
                    )}
                    <div
                      className={`border border-solid ${
                        // eslint-disable-next-line no-nested-ternary
                        ruleGroup?.unique_id === id
                          ? `bg-primary-500 ${
                              ruleGroup?.rule_group_is_active !== true
                                ? 'text-neutral-100 active'
                                : 'text-neutral-10 active'
                            }`
                          : ruleGroup?.rule_group_is_active !== true
                            ? 'text-neutral-100'
                            : ''
                      } border-neutral-40 rounded-lg  ${
                        ruleGroup?.rule_list?.length > 0
                          ? ' w-[calc(100%-26px)]'
                          : ' w-full'
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        const currentDate = moment();
                        const ruleGroupDate = moment(ruleGroup?.created_at);

                        if (currentDate.isSameOrAfter(ruleGroupDate, 'day')) {
                          handleSetActiveState('group', pageType);
                          setId(ruleGroup?.unique_id);
                        } else {
                          openNotificationWithIcon(
                            constants.error,
                            t('notifications.mutationError'),
                            t('notifications.futureTimeError')
                          );
                        }
                      }}
                    >
                      <div>
                        <div className="flex w-full">
                          <div className="flex w-full items-center">
                            <span
                              title={ruleGroup?.rule_group_name}
                              className="font-semibold text-neutral-700 text-md whitespace-nowrap overflow-hidden overflow-ellipsis text-left cursor-pointer w-[calc(100%-16px)] p-sm"
                            >
                              {ruleGroup?.rule_group_name}
                            </span>
                            <div className="rule-grid-delete-icon flex items-center p-sm">
                              {renderRuleGroupDeleteButton(ruleGroup)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {ruleGroup?.expanded ? (
                  <div
                    className="rule-list-submenu"
                    style={{ position: 'relative', paddingLeft: '20px' }}
                  >
                    {ruleGroup?.rule_list?.length > 0 ? (
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: '10px',
                          bottom: '52px',
                          width: '1px',
                        }}
                      />
                    ) : null}

                    {ruleGroup?.rule_list.map((rule, ruleIndex) => (
                      <div className="mt-sm" key={ruleIndex}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSetActiveState('rule', pageType);
                            setId(rule?.unique_id);
                          }}
                          // eslint-disable-next-line no-nested-ternary
                          className={`${
                            // eslint-disable-next-line no-nested-ternary
                            rule?.unique_id === id
                              ? `bg-primary-500 ${
                                  rule?.rule_is_active !== true
                                    ? 'text-neutral-100 active'
                                    : 'text-neutral-10 active'
                                })`
                              : rule?.rule_is_active !== true
                                ? 'text-neutral-100'
                                : ''
                          } cursor-pointer border border-solid border-gray-200 rounded-lg  w-[calc(100%-16px)] ml-md  relative`}
                        >
                          <div className="absolute top-1/2 left-[-23px] w-[20px] h-[1px] border-dashed border border-neutral-50" />
                          <div className="absolute bottom-[calc(50%-1px)] left-[-27px]  h-[calc(50%+22px)] border-dashed border border-neutral-50 " />
                          <div className="flex w-full">
                            <div className="block flex-1 w-1/2 p-sm">
                              <div className="flex">
                                <div className="overflow-hidden overflow-ellipsis">
                                  <span
                                    title={rule?.rule_name}
                                    className="font-semibold text-neutral-900 text-md whitespace-nowrap overflow-hidden overflow-ellipsis text-left cursor-pointer"
                                  >
                                    {' '}
                                    {rule?.rule_name}
                                  </span>
                                </div>
                              </div>
                              <div
                                title={rule?.rule_applicability?.value}
                                className={` whitespace-nowrap overflow-hidden overflow-ellipsis text-left cursor-pointer ${
                                  rule?.unique_id === id
                                    ? 'text-neutral-10 active '
                                    : ''
                                }`}
                              >
                                {rule?.rule_applicability?.value}
                              </div>
                            </div>
                            <div className="rule-grid-delete-icon flex items-center p-sm">
                              {renderRuleDeleteButton(rule)}
                            </div>
                            <div className="flex items-center p-sm">
                              {renderCopyButton(rule)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            ))
          : 'Kindly add Rule Group and Rule'}
      </div>
    </div>
  );
};

export default GroupRuleListSubcomponent;
